























































































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { currencyFormat } from '@/utils/helpers';
import { IPushTransaction, PayloadState } from '@/types/types';

@Component({
  name: 'PushResolveDialog',
  filters: { currencyFormat },
})
export default class PushResolveDialog extends Vue {
  @Prop({ required: true, default: false }) state!: boolean;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: null }) transaction!: IPushTransaction | null;
  @Prop({ default: 5 }) maxPushAttempts!: number;

  action: 'requeue' | 'mark-pushed' = 'requeue';
  reason: string = '';
  confirmedNotPushed: boolean = false;

  get isDuplicateReference(): boolean {
    return /already exist|duplicate|duplicat/i.test(this.transaction?.pushFailureReason ?? '');
  }

  // The API refuses these requeues without confirmedNotPushed=true.
  get needsConfirmation(): boolean {
    return (
      this.action === 'requeue' && (this.isDuplicateReference || this.transaction?.callbackPushStatus === 'PUSHED')
    );
  }

  get canSubmit(): boolean {
    if (this.action === 'mark-pushed') return !!this.reason;
    if (this.needsConfirmation) return this.confirmedNotPushed;
    return true;
  }

  @Watch('state')
  onStateChange(open: boolean): void {
    if (!open) return;
    // Default to the safe action when the downstream says it already has it.
    this.action = this.isDuplicateReference ? 'mark-pushed' : 'requeue';
    this.reason = '';
    this.confirmedNotPushed = false;
  }

  @Emit('actions')
  close(payload: PayloadState) {
    return payload;
  }

  @Emit('resolve')
  submit() {
    return {
      action: this.action,
      transactionId: this.transaction?._id,
      reason: this.reason || undefined,
      confirmedNotPushed: this.confirmedNotPushed || undefined,
    };
  }
}
